import { isDateBetween } from '@utils/isDateBetween';

let usualPrice = 1990;

export const STRESS_DATE_START = new Date(2025, 8, 12);
export const STRESS_DATE_END = new Date(2025, 8, 15); // +1 день, если по 14 сентября включительно
if (isDateBetween(STRESS_DATE_START, STRESS_DATE_END)) {
  usualPrice = 890;
}

export const DEFAULT_DESIGN_PRICE = usualPrice;

// на странице СФЗВ показываем цену SPECIAL_DESIGN_PRICE,
// а при создании заказа используем DEFAULT_DESIGN_PRICE и применяем SPECIAL_DESIGN_PROMO на 45%
export const SPECIAL_DESIGN_PROMO = 'sfzv-promo-20260522';
export const SPECIAL_DESIGN_PRICE = usualPrice * (1 - 0.45);
